import feriado from '@/repositories/conecta-sus/cadastro/feriado/feriadoRepository'

export default baseUrl => {

    return {
        feriado: feriado(baseUrl),
    }
}